const pathJoin = (...paths: string[]) => {
  const [pathname, queryParams] = paths.join('/').split('?');

  return `${pathname.replace(/\/{1,}/g, '/')}${queryParams ? `?${queryParams}` : ''}`;
};

export default pathJoin;
